import { PostBase } from 'domain/entity/PostBase'

export class PressRelease extends PostBase {
  constructor (id, categories, title, imageUrl, content, createdBy, createdAt, modifiedAt) {
    super(id, categories, title, imageUrl, content, createdBy, createdAt, modifiedAt)
    this.type = 'press_release'
    this.detailPathDir = '/PressReleaseDetail/'
  }
}
